package business

import kotlin.math.max

fun effectiveApecCardCostRub(
    baseCostRub: Double,
    discountRub: Double,
    enabled: Boolean,
): Double {
    return if (enabled) max(0.0, baseCostRub - discountRub) else baseCostRub
}
